module.exports = __webpack_public_path__ + "static/media/logo-AlfaCon.5f5dd58a.png";